import React, { FC } from 'react'

interface Props {
  list: {
    label: string
    value: number
    color: string
  }[]
  chartSize: number
  label?: boolean
  mutable?: boolean
}

const PieChart: FC<Props> = (props) => {
  const {
    list,
    chartSize,
    label,
    mutable,
  } = props

  const buildPieChart = () => {
    const sum = list.reduce((prev, val) => prev + val.value, 0)
    let count = 0
    const bgList: string[] = []
    list.forEach((value) => {
      bgList.push(`${value.color} ${(count / sum) * 100}%, ${value.color} ${(((count + value.value) / sum) * 100) - 0.3}%`)
      bgList.push(`#FFFFFF ${(((count + value.value) / sum) * 100) - 0.3}%, #FFFFFF ${((count + value.value) / sum) * 100}%`)
      count += value.value
    })

    if (!sum) {
      return (
        <div
          className="chart"
          style={{
            width: mutable ? "100%" : `${chartSize}px`,
            height: mutable ? "auto" : `${chartSize}px`,
            background:
              `radial-gradient(#FFFFFF 55%, transparent 55%), #EEEEEE`,
            paddingTop: mutable ? "100%" : "0",
            border: "1px solid #EEEEEE",
            borderRadius: "50%",
            margin: "auto",
          }}
        />
      )
    }
    return (
      <div
        className="chart"
        style={{
          width: mutable ? "100%" : `${chartSize}px`,
          height: mutable ? "auto" : `${chartSize}px`,
          background:
            `radial-gradient(#FFFFFF 55%, transparent 55%), conic-gradient(${bgList.join(', ')})`,
          paddingTop: mutable ? "100%" : "0",
          border: "1px solid #EEEEEE",
          borderRadius: "50%",
          margin: "auto",
        }}
      />
    )
  }

  return (
    <div className="pie_chart_wrap">
      {buildPieChart()}
      {
        label && (
          <div className="label_area">
            {
              list.map((value) => (
                <div
                  className="label"
                  key={`pie_legend_${value.label}`}
                >
                  <div
                    className="label_color"
                    style={{
                      backgroundColor: value.color,
                    }}
                  />
                  <div className="label_title">
                    {value.label}
                  </div>
                </div>
              ))
            }
          </div>
        )
      }
    </div>
  )
}

PieChart.defaultProps = {
  label: false,
  mutable: false,
}

export default PieChart
